import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Image from '../common/Image'
import Rating from '../common/Rating'
import LeftCaret from '../common/icons/LeftCaret'
import HotelAmenities from './HotelAmenities'
import HotelTags from '../../common/hotels/HotelTags'
import { MHotel } from '../types'
import {
  getMainImage,
  getRating,
  fetchHotel,
  isAllInclusiveRoom,
  getAllInclusiveVerbiageForRoom
} from '../helpers/hotelHelper'
import { SEARCH, SearchContext } from '../search/SearchContext'

import HotelRoomsCancellationPolicy from './HotelRoomsCancellationPolicy'
import HotelRoomsRateComments from './HotelRoomsRateComments'

import { Carousel } from 'react-responsive-carousel'
import { filterOnlyLoadedImages } from '../helpers/imageHelpers'

import { getQualifyingQuestions } from '../api/qualifyingQuestion'
import {
  shouldFetchQualifyingQuestions,
  isNotPriceApplicableUser
} from '../helpers/userHelper'


const HotelInfo = ({ hotel, actions, children, closeHandler }) => {
  const { state, dispatch } = React.useContext(SearchContext)
  const [featuredImages, setFeaturedImages] = useState(hotel.featured_images)

  useEffect(
    () => {
      const abortController = new AbortController()
      const signal = abortController.signal
      fetchHotel(hotel, { include: 'facilities', signal: signal }).then((response) => {
        dispatch({
          type: SEARCH.HOTEL.UPDATE,
          payload: {
            hotel: response.data.hotels,
            updateField: 'facilities',
          },
        })

        if (shouldFetchQualifyingQuestions(state.user)) {
          getQualifyingQuestions({
            zoneCode: response.data.hotels.zone_code,
            destinationCode: response.data.hotels.destination_code
          }).then((response) => {
            dispatch({
              type: SEARCH.QUALIFYING_QUESTIONS.SET,
              payload: response.data['qualifying_questions']
            })
          })
        }
      })

      loadImages()

      // Setting hotel info scroll to top
      let hotelInfo = document.querySelector(".info.scrollable")
      if(hotelInfo) hotelInfo.scrollTop = 0

      return () => {
        abortController.abort()
      }
    },
    [hotel.id]
  )

  const loadImages = () => {
    if (hotel.featured_images.length > 0) {
      let imagePaths = hotel.featured_images.map((image) => image.hd_size_image_url)
      filterOnlyLoadedImages(_imagesCallback, ...imagePaths)
    }
  }

  const _imagesCallback = (loaded) => {
    let paths = loaded.map(image => image.path)
    setFeaturedImages(
      hotel.featured_images.filter((image) => paths.some((path) => path.includes(image.hd_size_image_url)))
    )
  }

  const _renderCloseHandler = () => (
    <button
      className="close"
      onClick={closeHandler}
      aria-label="Close Open Hotel"
      >
      <LeftCaret />
    </button>
  )

  const _renderImages = () => {
    let images = featuredImages || hotel.image
    if (images && images.length > 1) {
      let imageStruc = images.map((image, idx) => (
        <figure className="image cropped" key={idx}>
          <img src={image['hd_size_image_url']} alt={hotel.name} />
        </figure>
      ))

      return (
        <Carousel showThumbs={false} showIndicators={false}>
          {imageStruc}
        </Carousel>
        )
    } else {
      return (
        <Image src={hotel.image || getMainImage(hotel.featured_images)} alt={hotel.name} />
      )
    }
  }

  return (
    <div id="hotel-info" className="details">
      {closeHandler && _renderCloseHandler()}

      <div className="info scrollable">
        {_renderImages()}

        <div className="hotel-info-content">
          <header className="header">
            <div className="text">
              <span className="title">{hotel.name}</span>
              {hotel.tags && <HotelTags tags={hotel.tags} />}
              <address>{hotel.address}</address>
              <Rating count={hotel.rating || getRating(hotel.code)} />
            </div>
          </header>

          <hr />

          <p className="description" dangerouslySetInnerHTML={{ __html: hotel.description }} />

          {children}

          {!isNotPriceApplicableUser(state.user) && (
            <>
              <HotelRoomsCancellationPolicy />
              <HotelRoomsRateComments />
            </>
          )}
          <div className="actions">{actions.map((component, index) => (
            <React.Fragment key={index}>
              { component }
            </React.Fragment>))}
          </div>
          {/* {hotel.facilities && <HotelAmenities amenities={hotel.facilities} />} */}
        </div>
      </div>
    </div>
  )
}

HotelInfo.propTypes = {
  hotel: MHotel.isRequired,
  children: PropTypes.node,
  actions: PropTypes.node,
  closeHandler: PropTypes.func,
}

export default HotelInfo
